import axios from 'axios'
import { ref } from '@vue/runtime-core'
import { SubjectModel } from '@/scripts/types/models'

export function useSubjects(initialValue: SubjectModel[] = [], multiple = false) {
    const subjects = ref<SubjectModel[]>(initialValue)
    const filterSubjects = (query: string) => {
        axios
            .get(route('admin.search.subjects'), {
                params: {
                    search: query,
                },
            })
            .then(({ data }) => {
                subjects.value.push(
                    ...data.subjects.filter(
                        (subject: SubjectModel) =>
                            !subjects.value.map((subject) => subject.sid).includes(subject.sid),
                    ),
                )
            })
    }
    const displayValue = (value: string | number | Array<string | number>) =>
        multiple && Array.isArray(value)
            ? subjects.value
                .filter((subject) => value.includes(subject.sid))
                .map((subject) => subject.course)
            : subjects.value.find((subject) => subject.sid === value)?.course ?? value

    return {
        subjects,
        filterSubjects,
        displayValue,
    }
}
